<template>
  <div class="card p-4">
    <div class="text-center process mx-auto">
      <img width="218" height="150" class="mb-4" alt="uploading" :src="uploadingImage" />
      <h5 class="mb-4">
        {{ $t('global.importData.uploading') }}
      </h5>
      <!-- TODO: show filename when uploading file   -->
      <p v-if="false" class="my-3">
        {{ fileName }}
      </p>
      <div class="text-start">
        <McProgressBar height="8px" :value="percentage" />
        <div class="d-flex align-items-center justify-content-between mt-4">
          <span class="__percentage">{{ percentage }}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uploadingImage from '@/assets/images/upload-in-progress.png'
import McProgressBar from '@/components/McProgressBar'

export default {
  components: {
    McProgressBar,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['finish-upload'],
  data() {
    return {
      percentage: 0,
      timer: null,
      fileName: '',
      uploadingImage,
    }
  },
  mounted() {
    this.pollData()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    pollData() {
      this.percentage = 0
      const self = this

      this.timer = setInterval(() => {
        // Fake loading until 80% to give time for API in case it's slow
        if (this.percentage < 80) {
          this.percentage += 1
        } else {
          clearInterval(this.timer)

          // Consistently checking whether optimize API is complete
          const finalizeInterval = setInterval(() => {
            // If the loading is finished, continue remaining progress until 100%
            if (this.isLoading) return

            const finalInterval = setInterval(() => {
              if (this.percentage < 100) {
                this.percentage += 1
              } else {
                clearInterval(finalInterval)

                self.$emit('finish-upload')
              }
            }, 30)

            if (!this.isLoading) {
              clearInterval(finalizeInterval)
            }
          }, 100)
        }
      }, 30)
    },
    handleRedirect(cb) {
      clearInterval(this.timer)

      setTimeout(cb, 2000)
    },
  },
}
</script>

<style lang="scss" scoped>
.process {
  max-width: 300px;
}

.__percentage {
  color: $blue;
  font-size: 16px;
  font-weight: 600;
}
</style>
